import styled from 'styled-components';

export const PageContent = styled.main`
  flex: 1;
  min-height: 100vh;
`;

export const SidebarWrapper = styled.nav<{$isCollapsed: boolean}>`
  display: none;
  flex-direction: column;
  row-gap: 0.5rem;
  border-radius: var(--radius-lg);
  overflow: hidden;
  flex-shrink: 0;
  max-height: calc(100vh - 100px);
  width: ${props => !props.$isCollapsed ? "var(--container-xs)" : "calc(var(--spacing) * 16)"};
  background-color: #fff;
  position: sticky;
  top: 80px;
  left: 0;
  transition: all 0.3s ease;
  z-index: 10;

  @media (min-width: 768px) {
    display: flex;
  }
`;

export const WrapperSectionContent = styled.section`
  max-width: var(--container-7xl);
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 2rem 1rem;
  
  @media (min-width: 768px) {
    padding: 3rem 1.5rem;  
  }

  & > * + * {
    margin-top: 1.5rem;

    @media (min-width: 768px) {
      margin-top: 2rem;
    }
  }
`;